import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  tabsOrder: [],
  tabsData: {},
};

export default (state = initialState, action) => {
  const switchMap = {};

  switchMap[types.CHANGE_TABS] = () => update(state, {
    $merge: { ...action.tabs },
  });
  return switchMap[action.type]
    ? switchMap[action.type]()
    : state;
};
